var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.onLine)?_c('a',{staticClass:"wifi online",attrs:{"href":"javascript:void(0)"}}):_c('a',{staticClass:"wifi offline",attrs:{"href":"javascript:void(0)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }